// src/components/admin/adminprofile/AdminProfile.jsx
import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiLock,
  FiCamera,
  FiSave,
  FiEye,
  FiEyeOff,
  FiShield,
  FiCheck,
  FiX,
} from "react-icons/fi";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../../assets/css/admin/auth/adminprofile/Adminprofile.css";
import AdminMasterLayout from "../../../../layouts/admin/AdminMasterLayout";
import AppContext from "../../../../contexts/AppContext";

const AdminProfile = () => {
  const { baseUrl, baseUrlForFiles, setAdmin, adminAuthToken } = useContext(AppContext);

  const [adminId, setAdminId] = useState(null);
  const [profileData, setProfileData] = useState({}); 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [role, setRole] = useState("Super Administrator");
  const [profileImage, setProfileImage] = useState(null);

  const [profileLoading, setProfileLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [passwordSaved, setPasswordSaved] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  // ── viewProfile ──────────────────────────────────────────
  const viewProfile = (admin) => {
    setProfileLoading(true);

    const id = admin?.id;

    const formdata = new FormData();
    formdata.append("admin_id", id);

    axios
      .post(`${baseUrl}/admin/profile/viewProfile`, formdata,
        {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      },
    ).then((response) => {
        console.log(response.data);

        if (response.data.success) {
          const data = response.data.admin;

          setAdminId(data.id);
          setName(data.name);
          setEmail(data.email);
          setPhoneNumber(data.phone_number);
          setRole(
            data.isSuperAdmin === 1
              ? "Super Administrator"
              : "Sub Administrator",
          );

          // profile_image — same key har jagah
          if (data.profile_image) {
            setProfileData({ profile_image: data.profile_image });
          }
        }

        setProfileLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setProfileLoading(false);
      });
  };

  // ── updateProfile ────────────────────────────────────────
  const updateProfile = () => {
    console.log(JSON.parse(localStorage.getItem("loggedInAdmin")));
    setSubmitLoading(true);

    const admin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const id = admin?.id;

    const formdata = new FormData();
    formdata.append("admin_id", id);
    formdata.append("name", name);
    formdata.append("email", email);
    formdata.append("phone_number", phoneNumber);

    if (profileImage) {
      formdata.append("profile_image", profileImage);
    }

    axios
      .post(`${baseUrl}/admin/profile/updateProfile`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success("Profile Updated Successfully");

          const updatedAdmin = response.data.admin;

          if (updatedAdmin) {
            localStorage.setItem("loggedInAdmin", JSON.stringify(updatedAdmin));
            setAdmin(updatedAdmin);
            viewProfile(updatedAdmin);
          }
        }

        setSubmitLoading(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Profile update failed. Please try again.");
        setSubmitLoading(false);
      });
  };

  // ── handlePasswordSave ───────────────────────────────────
  const handlePasswordSave = () => {
    setPasswordError("");
    if (!currentPassword)
      return setPasswordError("Current password is required.");
    if (newPassword.length < 8)
      return setPasswordError("New password must be at least 8 characters.");
    if (newPassword !== confirmPassword)
      return setPasswordError("Passwords do not match.");

    const admin = JSON.parse(localStorage.getItem("loggedInAdmin"));

    const formdata = new FormData();
    formdata.append("admin_id", admin?.id);
    formdata.append("current_password", currentPassword);
    formdata.append("new_password", newPassword);

    axios
      .post(`${baseUrl}/admin/changePassword`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success("Password Updated Successfully");
          setPasswordSaved(true);
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setTimeout(() => setPasswordSaved(false), 2500);
        } else {
          setPasswordError(response.data.message || "Something went wrong.");
        }
      })
      .catch((error) => {
        console.log(error);
        setPasswordError("Password update failed. Please try again.");
      });
  };

  // ── useEffect ────────────────────────────────────────────
  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    if (admin) {
      viewProfile(admin);
    }
  }, []);

  // ── Render ───────────────────────────────────────────────
  return (
    <AdminMasterLayout>
      <ToastContainer />
      <div className="ap-wrapper">
        <div className="ap-header">
          <h1 className="ap-page-title">Profile Management</h1>
          <span className="ap-page-sub">
            Manage your account settings and credentials
          </span>
        </div>

        {profileLoading ? (
          <div className="ap-loading">Loading profile...</div>
        ) : (
          <div className="ap-grid">
            {/* ── Left: Avatar Card ── */}
            <div className="ap-card ap-avatar-card">
              <div className="ap-avatar-wrap">
                <div className="ap-avatar-circle">
                  {profileData?.profile_image ? (
                    <img
                      src={
                        profileData.profile_image.includes("admin")
                          ? `${baseUrlForFiles}/${profileData.profile_image}`
                          : profileData.profile_image
                      }
                      alt="avatar"
                      className="ap-avatar-img"
                    />
                  ) : (
                    <span>{(name?.[0] || "A").toUpperCase()}</span>
                  )}

                  {/* customer jaisa — label + Form.Control */}
                  <label
                    htmlFor="admin-profile-upload"
                    className="ap-avatar-overlay"
                  >
                    <FiCamera />
                    <Form.Control
                      type="file"
                      id="admin-profile-upload"
                      accept="image/*"
                      onChange={(e) => {
                        setProfileImage(e.target.files[0]);
                        const reader = new FileReader();
                        reader.onload = () => {
                          setProfileData({
                            ...profileData,
                            profile_image: reader.result,
                          });
                        };
                        reader.readAsDataURL(e.target.files[0]);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
              </div>
              <h2 className="ap-avatar-name">{name || "Admin"}</h2>
              <span className="ap-avatar-role">
                <FiShield className="ap-role-icon" />
                {role}
              </span>
              <span className="ap-avatar-email">{email}</span>
            </div>

            {/* ── Right: Forms ── */}
            <div className="ap-forms-col">
              {/* Personal Info Card */}
              <div className="ap-card">
                <div className="ap-card-header">
                  <FiUser className="ap-card-icon" />
                  <h3>Personal Information</h3>
                </div>

                <div className="ap-fields">
                  <div className="ap-field">
                    <label className="ap-label">Full Name</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiUser />
                      </span>
                      <input
                        className="ap-input"
                        type="text"
                        placeholder="Enter full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="ap-field">
                    <label className="ap-label">Email Address</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiMail />
                      </span>
                      <input
                        className="ap-input"
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="ap-field">
                    <label className="ap-label">Phone Number</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiPhone />
                      </span>
                      <input
                        className="ap-input"
                        type="tel"
                        placeholder="Enter phone number"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="ap-field">
                    <label className="ap-label">Role</label>
                    <div className="ap-input-wrap ap-input-wrap--disabled">
                      <span className="ap-input-icon">
                        <FiShield />
                      </span>
                      <input
                        className="ap-input"
                        type="text"
                        value={role}
                        disabled
                        readOnly
                      />
                      <span className="ap-badge">Read Only</span>
                    </div>
                  </div>
                </div>

                <div className="ap-card-footer">
                  <button
                    className="ap-btn-save"
                    onClick={updateProfile}
                    disabled={submitLoading}
                  >
                    {submitLoading ? (
                      <>Saving...</>
                    ) : (
                      <>
                        <FiSave /> Save Changes
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Change Password Card */}
              <div className="ap-card">
                <div className="ap-card-header">
                  <FiLock className="ap-card-icon" />
                  <h3>Change Password</h3>
                </div>

                <div className="ap-fields">
                  <div className="ap-field">
                    <label className="ap-label">Current Password</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiLock />
                      </span>
                      <input
                        className="ap-input"
                        type={showCurrent ? "text" : "password"}
                        placeholder="Enter current password"
                        value={currentPassword}
                        onChange={(e) => {
                          setCurrentPassword(e.target.value);
                          setPasswordError("");
                        }}
                      />
                      <button
                        className="ap-pass-toggle"
                        onClick={() => setShowCurrent((p) => !p)}
                        tabIndex={-1}
                      >
                        {showCurrent ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>

                  <div className="ap-field">
                    <label className="ap-label">New Password</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiLock />
                      </span>
                      <input
                        className="ap-input"
                        type={showNew ? "text" : "password"}
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => {
                          setNewPassword(e.target.value);
                          setPasswordError("");
                        }}
                      />
                      <button
                        className="ap-pass-toggle"
                        onClick={() => setShowNew((p) => !p)}
                        tabIndex={-1}
                      >
                        {showNew ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>

                  <div className="ap-field">
                    <label className="ap-label">Confirm New Password</label>
                    <div className="ap-input-wrap ap-input-wrap--active">
                      <span className="ap-input-icon">
                        <FiLock />
                      </span>
                      <input
                        className="ap-input"
                        type={showConfirm ? "text" : "password"}
                        placeholder="Enter confirm password"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setPasswordError("");
                        }}
                      />
                      <button
                        className="ap-pass-toggle"
                        onClick={() => setShowConfirm((p) => !p)}
                        tabIndex={-1}
                      >
                        {showConfirm ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>
                  </div>
                </div>

                {passwordError && (
                  <div className="ap-error">
                    <FiX className="ap-error-icon" /> {passwordError}
                  </div>
                )}

                <div className="ap-card-footer">
                  <button
                    className={`ap-btn-save ${passwordSaved ? "ap-btn-save--done" : ""}`}
                    onClick={handlePasswordSave}
                  >
                    {passwordSaved ? (
                      <>
                        <FiCheck /> Password Updated!
                      </>
                    ) : (
                      <>
                        <FiLock /> Update Password
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminMasterLayout>
  );
};

export default AdminProfile;